import { Skeleton } from "@/ui/primitives/skeleton";
import { EmptyState } from "@/ui/patterns";
import type { Activity } from "@/domain/activity/types";
import { ActivityRow } from "./ActivityRow";

interface ActivityListProps {
  activities: Activity[];
  isLoading: boolean;
  onPublishOffer: (activity: Activity) => void;
  onEdit: (activity: Activity) => void;
  onDelete: (activity: Activity) => void;
}

export default function ActivityList({
  activities,
  isLoading,
  onPublishOffer,
  onEdit,
  onDelete,
}: ActivityListProps) {
  if (isLoading) {
    return (
      <ul className="divide-y divide-border border-y border-border">
        {[1, 2, 3].map((row) => (
          <li key={row} className="py-4">
            <Skeleton className="h-12 w-full" />
          </li>
        ))}
      </ul>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="border border-dashed border-border rounded-xl">
        <EmptyState
          title="Zatím tu není žádná šablona slev"
          description="Šablona slev popisuje, co u vás lidé dělají — lekce jógy, masáž, kvíz. Z každé pak vypíšete slevový termín. První přidáte tlačítkem „Nová šablona slev“ nahoře."
        />
      </div>
    );
  }

  return (
    <ul className="divide-y divide-border border-y border-border">
      {activities.map((activity) => (
        <ActivityRow
          key={activity.id}
          activity={activity}
          onPublishOffer={onPublishOffer}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </ul>
  );
}
